import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ComponentChanges } from '../../../../../models/component-changes.model';
import { DatePickerInlineBaseComponent } from '../date-picker-inline-base/date-picker-inline-base.component';
import * as moment from 'moment';

/**
 * This interface is used to represent year on calendar view
 */
interface Year {
  date: moment.Moment;
  current: boolean;
}

/**
 * This component is used for displaying list of years to select
 */
@Component({
  selector: 'ideom-date-picker-inline-years',
  templateUrl: './date-picker-inline-years.component.html',
  styleUrls: ['./date-picker-inline-years.component.scss'],
})
export class DatePickerInlineYearsComponent extends DatePickerInlineBaseComponent implements OnChanges {
  /**
   * The item click event
   */
  @Output() itemClick: EventEmitter<void> = new EventEmitter<void>();

  /**
   * The count of years on page to display
   */
  @Input() pageSize = 9;

  years: Year[] = [];
  columnsCount: number;

  constructor() {
    super();
  }

  /**
   * @ignore
   * @param changes
   */
  ngOnChanges(changes: ComponentChanges<DatePickerInlineYearsComponent>): void {
    if (changes.current) {
      this.updateYears();
    }
    if (changes.pageSize) {
      this.columnsCount = Math.ceil(Math.sqrt(this.pageSize));
    }
  }

  /**
   * This method is used for updating years
   * @private
   */
  private updateYears(): void {
    const years = [];

    const delta = Math.round((this.pageSize - 1) / 2);
    const startYear = moment(this.current).startOf('year').add(-delta, 'years');
    const endYear = moment(this.current).startOf('year').add(delta, 'years');
    let year = moment(startYear);

    while (year.isSameOrBefore(endYear, 'year')) {
      years.push({
        date: year,
        current: year.isSame(this.current, 'year'),
      });
      year = moment(year).add(1, 'year');
    }

    this.years = years;
  }

  /**
   * This method is used for handling year click
   * @param year The year
   */
  onYearClick(year: Year): void {
    this.currentChange.emit(moment(year.date));
    this.itemClick.emit();
  }
}
